var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9304 9.35843C12.9349 8.92013 12.5863 8.57008 12.1482 8.57661L8.40152 8.63249C7.35105 8.634 7.34879 10.2201 8.39926 10.2186L9.68033 10.2145C9.97203 10.2135 10.0402 10.3821 9.83518 10.5884L7.27672 13.1632C6.96932 13.4726 6.96985 13.9747 7.2765 14.2833C7.58378 14.5926 8.08376 14.5908 8.38949 14.2831L10.9479 11.7083C11.1541 11.5008 11.3205 11.5706 11.3195 11.8641L11.3152 13.1532C11.3139 14.2106 12.8898 14.2081 12.8913 13.1509L12.9304 9.35843Z",
    fill: "#34657F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.201 4.5H0.789062V6.08823H19.201V4.5Z",
    fill: "#34657F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31527 0L5.17972 1.9943e-05C5.65948 2.24312e-05 6.25741 0.224462 6.61894 0.54146L7.46001 1.27892C7.53364 1.34348 7.76249 1.42962 7.86192 1.42962H18.6857C19.4103 1.42962 20.0005 2.02243 20 2.7531L19.9904 16.6776C19.9899 17.4096 19.4009 18 18.6747 18H1.31535C0.590094 18 0 17.409 0 16.6784V1.32157C0 0.592916 0.589809 -3.7588e-06 1.31527 0ZM1.57816 1.58823V16.4118H18.4125L18.4217 3.01785H7.86192C7.38163 3.01785 6.78448 2.79309 6.42331 2.47641L5.58224 1.73895C5.50862 1.6744 5.27911 1.58825 5.17971 1.58825L1.57816 1.58823Z",
    fill: "#34657F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report-icon.515f85c5e3fc4b62deec69ddb1986abc.svg";
export { ForwardRef as ReactComponent };